import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { screen } from 'components/styles/variables';
import { useRouter } from 'next/router';
import tapEvent, { FooterAction } from 'lib/Tracking/Footer/TapEvent';
import useEvents from 'lib/hooks/useEvents';
import { SourcePages } from 'lib/EventSchema';

const TERMS = Object.freeze([
  {
    href: '/pages/terms',
    title: 'footer.termsOfUse',
    trackingSection: 'terms_of_use',
  },
  {
    href: '/pages/privacy',
    title: 'footer.privacyPolicy',
    trackingSection: 'privacy_policy',
  },
  { href: '/ccpa/opt-out', title: 'footer.ccpa', trackingSection: 'ccpa' },
]);

export default function Terms(): JSX.Element {
  const { t } = useTranslation();
  const logger = useEvents();
  const { asPath } = useRouter();

  return (
    <div className="terms">
      {TERMS.map(({ href, title, trackingSection }) => (
        <Link key={title} href={href}>
          <a
            className="link"
            onClick={(): void => {
              logger.log(
                tapEvent({
                  action: trackingSection as FooterAction,
                  pathName: asPath as SourcePages,
                })
              );
            }}
          >
            {t(title)}
          </a>
        </Link>
      ))}
      <style jsx>{`
        .terms {
          font-size: 14px;
          margin-bottom: 32px;
        }

        a {
          color: white;
        }

        .terms a {
          margin-right: 20px;
        }

        .terms a:last-child {
          margin-right: 0px;
          display: block;
        }

        @media (min-width: ${screen.mdMin}) {
          .terms a:last-child {
            display: inline-block;
          }
        }
      `}</style>
    </div>
  );
}
